<div class="container">
  <div id="print-section">

    <!-- HEADER -->
    <div class="row header">

      <!-- BOOK NAME -->
      <div class="col-6 text-center">
        <div style="font-size:14px;font-weight:bold;">
          पुस्तकाचे नाव:
          <span>{{ bookwise }}</span>
        </div>
      </div>

      <!-- DATE -->
      <div class="col-3 text-end">
        <b>दिनांक:</b> {{ today }}
      </div>

    </div>

    <hr>

    <!-- BUTTONS -->
    <div class="text-end mb-2">
      <button mat-raised-button color="primary" (click)="saveData()">Save</button>
      <button mat-raised-button color="primary" (click)="printPage()">Print</button>
      <button mat-raised-button mat-dialog-close>Close</button>
    </div>

    <!-- TABLE HEADER -->
    <div class="row table-header">

      <div class="col col-2">
        <input type="checkbox" [(ngModel)]="masterSelected" (change)="checkUncheckAll()" />
        वितरक
      </div>

      <div class="col col-1">जिल्हा</div>
      <div class="col col-1">तालुका</div>

      <div class="col col-1">विक्री</div>
      <div class="col col-1">भेट</div>
      <div class="col col-1">कॉम्प</div>

      <div class="col col-1">जादा</div>
      <div class="col col-1">एकूण</div>

      <div class="col col-1">वितरण</div>
      <div class="col col-1">सब</div>

      <div class="col col-1">Action</div>

    </div>

    <!-- DATA ROWS -->
    <div *ngFor="let item of combinedList" class="row table-row">

      <div class="col col-2 text-start">
        <input type="checkbox" [(ngModel)]="item.selected" (change)="checkboxChanged()" />
        {{ item.DistributiveRep || 'अनिर्धारित'}}
      </div>

      <div class="col col-1">{{ item.district }}</div>
      <div class="col col-1">{{ item.taluka }}</div>

      <div class="col col-1">{{ item.normal_copies }}</div>
      <div class="col col-1">{{ item.sponsor_copies }}</div>
      <div class="col col-1">{{ item.complimentary_copies }}</div>

      <div class="col col-1">
        <input type="number" [(ngModel)]="item.jyda" (ngModelChange)="onJydaChange(item)" />
      </div>

      <div class="col col-1"><b>{{ item.row_total }}</b></div>

      <div class="col col-1">{{ item.DistributionMode }}</div>
      <div class="col col-1">{{ item.SubDistMode }}</div>

      <div class="col col-1">
        <button mat-raised-button color="accent" (click)="openSaveDialog(item)">Update</button>
      </div>

    </div>

    <!-- TOTAL -->
    <div class="row total-row">

      <div class="col col-2"><b>एकूण</b></div>

      <div class="col col-1"></div>
      <div class="col col-1"></div>

      <div class="col col-1">{{ totalNormal }}</div>
      <div class="col col-1">{{ totalSponsor }}</div>
      <div class="col col-1">{{ totalComplimentary }}</div>

      <div class="col col-1">{{ totalJyda }}</div>
      <div class="col col-1">{{ grandTotal }}</div>

      <div class="col col-1"></div>
      <div class="col col-1"></div>
      <div class="col col-1"></div>

    </div>

  </div>
</div>